import { render, staticRenderFns } from "./MonsterSlotMarker.vue?vue&type=template&id=4145b35c&scoped=true"
import script from "./MonsterSlotMarker.vue?vue&type=script&lang=js"
export * from "./MonsterSlotMarker.vue?vue&type=script&lang=js"
import style0 from "./MonsterSlotMarker.vue?vue&type=style&index=0&id=4145b35c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145b35c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4145b35c')) {
      api.createRecord('4145b35c', component.options)
    } else {
      api.reload('4145b35c', component.options)
    }
    module.hot.accept("./MonsterSlotMarker.vue?vue&type=template&id=4145b35c&scoped=true", function () {
      api.rerender('4145b35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MonsterSlotMarker.vue"
export default component.exports